import AccountAPI from '@/modules/account/constants/account.api.uri.const'
import { defineStore } from 'pinia'
import { uuid } from 'vue3-uuid'
import BrokerAPI from '../constants/broker.api.uri.const'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import { formatDataBrokerDetail } from '../helper/table'

export enum BrokerDetailActionType {
  FETCHING = 'fetching',
  FETCHED = 'fetched',
  FETCH_FAILED = 'fetch_failed',
  CREATING = 'creating',
  CREATED = 'created',
  CREATE_FAILED = 'create_failed',
  UPDATING = 'updating',
  APPROVING = 'approving',
  APPROVED = 'approved',
  APPROVE_FAILED = 'approve_failed',
  REJECTING = 'rejecting',
  REJECTED = 'rejected',
  REJECT_FAILED = 'reject_failed',
}

interface BrokerDetail {
  id: number
  code: string
  fullname: string
  phone: string
  email: string
  status: string
  profile_pic: string | null
  created_at: string
  updated_at: string
  role: object
  perms: string[]
}

interface BrokerDetailState {
  accounts: {
    [key: string]: {
      action_type: BrokerDetailActionType,
      approve_type: BrokerDetailActionType,
      action_message: string,
      account: BrokerDetail
    }
  }
}

export const useBrokerDetailStore = defineStore('broker.detail', {
  state: (): BrokerDetailState => ({
    accounts: {},
  }),
  getters: {},
  actions: {
    async fetchBrokerDetail(id: number, type: string) {
      console.log('type fetchBrokerDetail', type);

      return new Promise(async (resolve, reject) => {
        try {
          this.accounts[id] = {
            ...this.accounts[id],
            action_type: type === 'update' ? BrokerDetailActionType.FETCHED : BrokerDetailActionType.FETCHING,
          }
          const res: any = await APIClient.get(BrokerAPI.broker.detail.replace(':id', id.toString()))
          const { data } = res.data;

          this.accounts[id] = {
            action_type: BrokerDetailActionType.FETCHED,
            action_message: res?.data?.message,
            account: formatDataBrokerDetail(data),
          }
          resolve(data);
        } catch (e) {
          console.log(e, 'eeee');

        }
      })

    },
    async setBrokerDetail(id: number, account: Object) {
      this.accounts[id] = {
        action_type: BrokerDetailActionType.FETCHED,
        action_message: '',
        account: {...this.accounts[id].account, ...account},
      }
    },
    async approveBroker(id: number) {
      try {
        //approving
        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: BrokerDetailActionType.APPROVING,
        }
        const res: any = await APIClient.post(BrokerAPI.broker.approve.replace(':id', id.toString()))
        const { data } = res.data;

        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: BrokerDetailActionType.APPROVED,
          action_message: res?.data?.message,
          account: data,
        }
        return res;
      } catch (error) {

        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: BrokerDetailActionType.APPROVE_FAILED,
          action_message: '',
          account: this.accounts[id].account,
        }
        return error;
      }
    },
    async rejectBroker(id: number) {
      try {
        //rejecting
        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: BrokerDetailActionType.REJECTING,
        }
        const res: any = await APIClient.post(BrokerAPI.broker.reject.replace(':id', id.toString()), {
          reason: 'Hệ Thống chưa xác thực được bạn',
        })
        const { data } = res.data;

        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: BrokerDetailActionType.REJECTED,
          action_message: res?.data?.message,
          account: data,
        }
        return res;
      } catch (error) {

        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: BrokerDetailActionType.REJECT_FAILED,
          action_message: '',
          account: this.accounts[id].account,
        }
        return error;
      }
    },
  },
})
